import { render, staticRenderFns } from "./PageContato.vue?vue&type=template&id=3aa9e9be&scoped=true&"
import script from "./PageContato.vue?vue&type=script&lang=js&"
export * from "./PageContato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa9e9be",
  null
  
)

export default component.exports